(() => {
  const config = document.currentScript.dataset;
  let loading;
  let refreshStarted = false;
  window.cbLoadLipscore = () => {
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      window.lipscoreInit = () => window.lipscore.init({ apiKey: config.lipscoreApiKey });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://static.lipscore.com/assets/${encodeURIComponent(config.lipscoreLocale)}/lipscore-v1.js`;
      const timeout = setTimeout(() => fail(), 20000);
      const fail = () => {
        clearTimeout(timeout);
        script.remove();
        loading = null;
        reject(new Error('Lipscore could not be loaded'));
      };
      script.onerror = fail;
      script.onload = () => {
        clearTimeout(timeout);
        // Match the app's existing repeat initialization for dynamic products.
        if (!refreshStarted) {
          refreshStarted = true;
          const refresh = () => {
            try { window.lipscore.initWidgets(); } catch { /* Initialization may still be pending. */ }
            setTimeout(refresh, 1000);
          };
          refresh();
        }
        resolve();
      };
      document.head.appendChild(script);
    });
    return loading;
  };
  if (config.cbManual !== 'true') window.cbLoadLipscore().catch(() => {});
})();
